import React, { Text } from 'react';
import PropTypes from 'prop-types';
import { formatLongToDate, formatLongToDateHM } from '../../../helpers/Data';
import * as actions from '../../../view/formulario/actions/FormActions';
import { View, FieldsGroup, FieldDetail, ButtonFields, Progress, LinkAction, CalendarField } from 'react-template';
import { TextArea, Dropdown, TextField } from "semantic-ui-react";

class EditSubscriptionView extends View {
    constructor(props) {
        super(props);
        this.state = {
            cpf: '',
            idSubmissao: '',
            idForm: '',
            tituloFormulario: '',
            descricaoFormulario: '',
            permissaoFormulario: '',
            dataSubmissao: '',
            itensSubmissao: '',
            itensComCertificado: '',
            itensComArquivo: '',
            pesquisa_submissao: true,
            valorBoleto: 0,
            certificadoDisponivel: false,
            statusLoader: false,
            submissao: {},
            fields: {}
        }

        this.changeStatusLoader = this.changeStatusLoader.bind(this)
    }

    componentWillMount() {
        this.setConteudoSubmissao(this.props.submissao);
    }

    setConteudoSubmissao(submissao) {
        let { itensSubmissao, itensComCertificado, itensComArquivo, fields, itens } = this.getItensSubmissao(submissao);
        this.setState({
            cpf: submissao.cpf,
            idSubmissao: submissao.id,
            idForm: submissao.form.id,
            tituloFormulario: JSON.parse(submissao.form.formSchema).schema.title,
            descricaoFormulario: JSON.parse(submissao.form.formSchema).schema.description,
            permissaoFormulario: submissao.form.permissao,
            dataSubmissao: submissao.dataSubmissao,
            itensSubmissao: itensSubmissao,
            itensComCertificado: itensComCertificado,
            itensComArquivo: itensComArquivo,
            pesquisa_submissao: this.props.pesquisa_submissao,
            valorBoleto: submissao.valorBoleto,
            submissao: submissao,
            fields: fields,
            itens: itens
        });
    }

    getItensSubmissao(submissao) {
        const itens = JSON.parse(submissao.form.formEditavel).itens

        const formSchema = JSON.parse(submissao.form.formSchema)
        let itensSubmissao = [];
        let itensComCertificado = [];
        let itensComArquivo = [];
        let fields = [];
        let dadosFormJson = JSON.parse(submissao.dadosForm.replace(/'/g, '"'));

        for (let itemName in dadosFormJson) {
            // pega o index o item
            var i = itemName.split('_')[1];
            const itemSubmissao = dadosFormJson[itemName];
            const itemTitulo = (formSchema.schema.properties[itemName] !== undefined ? formSchema.schema.properties[itemName].title : 'Questão removida do formulário');

            let tipo = null
            const iFind = itens.find(item => {
                return item.id === parseInt(i, 10)
            })

            if (iFind) tipo = iFind.tipo

            // separa os que tem e não tem certificado
            if (itemTitulo === 'Questão removida do formulário') {
                itensSubmissao.push({ titulo: itemTitulo, resposta: itemSubmissao, tipo });
                fields[itemTitulo] = true;
            } else if ((itens.find(item => item.id + '' === i) !== undefined) && (itens.find(item => item.id === parseInt(i, 10)).certificado)) {
                itensComCertificado.push({ titulo: itemTitulo, resposta: itemSubmissao, itemId: i });
            } else if ((itens.find(item => item.id + '' === i) !== undefined) && itens.find(item => item.id === parseInt(i, 10)).tipo === "arquivo") {
                itensComArquivo.push({ titulo: itemTitulo, resposta: itemSubmissao });
            } else {
                itensSubmissao.push({ titulo: itemTitulo, resposta: itemSubmissao, tipo });
                fields[itemTitulo] = true;
            }
        }
        return { itensSubmissao, itensComCertificado, itensComArquivo, fields, itens };
    }

    getContent() {
        if (this.state.submissao.pesquisa_submissao) { //Visualização
            return this.getViewContent()
        } else { //Edição
            return this.getEditContent()
        }
    }

    getItemData(item) {
        if (item.tipo === "data") {
            return (
                <FieldDetail width={4} titulo={item.titulo}>{formatLongToDate(item.resposta)}</FieldDetail>
            )
        }

        return (
            <FieldDetail width={4} titulo={item.titulo}>{item.resposta}</FieldDetail>
        )
    }

    changeStatusLoader() {
        this.setState({ statusLoader: !this.state.submissao.statusLoader })
    }



    filtroItemSubmissao(titulo) {
        return this.state.submissao.itensSubmissao.filter(e => { return (e.titulo == titulo) })[0];
    }


    getFieldIndexByTitle(title) {
        for (var index = 0; index < this.state.itens.length; index++) {
            if (this.state.itens[index].pergunta == title) {
                return index;
            }
        }
        return -1;
    }

    makeDadosForms() {
        const dadosFormObject = {};
        for (var i = 0; i < this.state.itensSubmissao.length; i++) {
            dadosFormObject['questao_' + i] = this.state.itensSubmissao[i].resposta;
        }
        return dadosFormObject
    }

    updateField(event, itemTitulo) {

        const index = this.getFieldIndexByTitle(itemTitulo);
        const newItems = [...this.state.itensSubmissao];
        newItems[index].resposta = event.target.value;
        this.setState({ itensSubmissao: newItems });
        this.updateColumn(itemTitulo, event.target.value);
    }

    updateColumn(titulo, novoValor) {
        if (titulo == "Nome") {
            var newSub = this.state.submissao;
            newSub.nome = novoValor
            this.setState({ submissao: newSub });
        } else if (titulo == "CPF") {
            var newSub = this.state.submissao;
            newSub.cpf = novoValor
            this.setState({ submissao: newSub });
        }
    }

    enableDisable(event, titulo) {
        var newFields = this.state.fields;
        newFields[titulo] = !newFields[titulo];
        this.setState({ fields: newFields })
    }

    disableField(titulo) {
        var newFields = this.state.fields;
        newFields[titulo] = true;
        this.setState({ fields: newFields })
    }

    updateSubscription(event, titulo) {
        const editSubmissao = { ...this.state.submissao }
        const novodadosForm = this.makeDadosForms();
        editSubmissao.dadosForm = JSON.stringify(novodadosForm);
        actions.enviarReSubmissao(this.state.idSubmissao, this.state.idForm, editSubmissao);
        this.disableField(titulo)
    }

    getOptionsObjectFromArray(index) {
        var optionsObject = []
        if (this.state.itens[index].tipo == "radio") {
            this.state.itens[index].opcoes.map(opcao => {
                optionsObject.push({
                    key: opcao.texto,
                    text: opcao.texto,
                    value: opcao.texto,
                })
            })
        }
        return optionsObject;
    }


    getFieldDetail(item) {
        
        var index = this.getFieldIndexByTitle(item.titulo);
        if (this.state.itens[index].tipo == "radio" || this.state.itens[index].tipo == "select") {
            return (
                <div style={{ width: "100%", borderColor: "black" }}>
                    <label style={{ fontWeight: "bold", textAlign: "left" }}>{item.titulo}</label>
                    <div>
                        <Dropdown style={{ width: "100%", borderColor: "black" }} value={item.resposta} fluid selection options={this.getOptionsObjectFromArray(index)} onChange={e => this.updateField(e, item.titulo)} disabled={this.state.fields[item.titulo]} />
                    </div>
                    <ButtonFields color="white">
                        <LinkAction icone="save" type="table" onClick={(e) => this.updateSubscription(e, item.titulo)} tooltip="Salvar alteração" />
                    </ButtonFields>
                    <ButtonFields color="white">
                        <LinkAction icone="edit" type="table" onClick={(e) => this.enableDisable(e, item.titulo)} tootip="Editar esse campo" />
                    </ButtonFields>
                </div>
            );
        } else if (this.state.itens[index].tipo == "textocurto-dinheiro") {
            return (
                <div style={{ width: "100%", borderColor: "black" }}>
                    <label style={{ fontWeight: "bold", textAlign: "left" }}>{item.titulo}</label>
                    <div>
                    <TextArea type="number" style={{ width: "100%", borderColor: "black", padding: "5px" }} value={item.resposta} onChange={e => this.updateField(e, item.titulo)} disabled={this.state.fields[item.titulo]} />
                    </div>
                    <ButtonFields color="white" >
                        <LinkAction icone="save" type="table" onClick={(e) => this.updateSubscription(e, item.titulo)} tooltip="Salvar alteração" />
                    </ButtonFields>
                    <ButtonFields color="white" >
                        <LinkAction icone="edit" type="table" onClick={(e) => this.enableDisable(e, item.titulo)} tootip="Editar esse campo" />
                    </ButtonFields>
                </div>
            );
        }
        else if (this.state.itens[index].tipo == "data") {
            return (
                <div style={{ width: "100%", borderColor: "black" }}>
                    <label style={{ fontWeight: "bold", textAlign: "left" }}>{item.titulo}</label>
                    <div>
                    <CalendarField value={item.resposta} onChange={e => this.updateField(e, item.titulo)} disabled={this.state.fields[item.titulo]} />
                    </div>
                    <ButtonFields color="white" >
                        <LinkAction icone="save" type="table" onClick={(e) => this.updateSubscription(e, item.titulo)} tooltip="Salvar alteração" />
                    </ButtonFields>
                    <ButtonFields color="white" >
                        <LinkAction icone="edit" type="table" onClick={(e) => this.enableDisable(e, item.titulo)} tootip="Editar esse campo" />
                    </ButtonFields>
                </div>
            );
        }
        else {
            return (
                <div style={{ width: "100%", borderColor: "black" }}>
                    <label style={{ fontWeight: "bold", textAlign: "left" }}>{item.titulo}</label>
                    <div>
                    <TextArea  style={{ width: "100%", borderColor: "black", padding: "5px" }} value={item.resposta} onChange={e => this.updateField(e, item.titulo)} disabled={this.state.fields[item.titulo]} />
                    </div>
                    <ButtonFields color="white" >
                        <LinkAction icone="save" type="table" onClick={(e) => this.updateSubscription(e, item.titulo)} tooltip="Salvar alteração" />
                    </ButtonFields>
                    <ButtonFields color="white" >
                        <LinkAction icone="edit" type="table" onClick={(e) => this.enableDisable(e, item.titulo)} tootip="Editar esse campo" />
                    </ButtonFields>
                </div>
            );
        }
    }


    getEditContent() {
        return (
            <div>
                {this.state.itensSubmissao.map(item => this.getFieldDetail(item))}
            </div>
        )
    }

    renderCertificate() {
        if (this.state.submissao.itensComCertificado.length > 0 || this.props.tem_presenca) {
            return this.hasCertificate(this.state.submissao.itensComCertificado);
        }
    }

    render() {
        return (
            <div className='edit-subscription-view'>
                {this.state.submissao.statusLoader && <Progress position={'bottom'} />}
                {this.getContent()}
            </div>
        );
    }
}

EditSubscriptionView.propTypes = {
    submissao: PropTypes.object.isRequired
}

export default EditSubscriptionView;


// WEBPACK FOOTER //
// ./src/components/formbuilder/editor/EditSubscriptionView.js